<template>
  <a-dropdown v-if="currentUser && currentUser.name" placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar class="avatar" size="small" :src="avatar" shape="circle" />
      <span class="name">{{ name }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="center" v-show="false" @click="handleToCenter">
          <a-icon type="user" />
          {{ $t('menu.account.center') }}
        </a-menu-item>
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          {{ $t('menu.account.settings') }}
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          {{ $t('menu.account.logout') }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" class="ml8 mr8" />
  </span>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { mapState } from 'vuex'
export default {
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      avatar: 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png'
    }
  },
  methods: {
    handleToCenter () {
      this.$router.push({ path: '/account/center' })
    },
    handleToSettings () {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout (e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          return this.$store.dispatch('Logout').then((res) => {
            if (res) {
              sessionStorage.setItem('redirect', this.$route.fullPath);
              if (process.env.NODE_ENV !== 'development' && localStorage.getItem('isFromSystemLogin') !== 'true') {
                // location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + '/' + location.hash;
                location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + this.$route.fullPath;
              } else {
                localStorage.removeItem('isFromSystemLogin')
                // this.$router.push({ name: 'login' })
                this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } })
              }
            }
          })
        },
        onCancel () {}
      })
    }
  },
  computed: {
    ...mapState({
      name: (state) => state.user.name
      // avatar: (state) => state.user.avatar
    })
  }
}
</script>

<style lang="less" scoped>
.ant-pro-account-avatar {
  .avatar, .name {
    align-self: center;
  }
  .avatar {
    margin-right: 8px;
    margin-top: -5px;
  }
  .name {
    font-weight: 500;
  }
}
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
